import CreditProducts from './CreditProducts';

export default CreditProducts;
